function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M55 38.2377C55 30.0021 49.5983 22.8067 41.981 20.6384C41.5022 9.17492 32.2757 0 21.001 0C9.42081 0 0 9.67798 0 21.5743C0 25.4513 1.00456 29.2262 2.91214 32.5403L0.0772095 43.0688L10.3263 40.1569C13.2918 41.9583 16.637 42.9731 20.0896 43.1261C22.1998 50.9518 29.2045 56.5014 37.2217 56.5014C40.4217 56.5014 43.5336 55.6259 46.2678 53.9624L54.9224 56.4216L52.5285 47.5308C54.1478 44.7219 55 41.5251 55 38.2377ZM10.8349 36.5773L4.69929 38.3209L6.39664 32.0178L6.00975 31.3962C4.18652 28.4658 3.22266 25.0694 3.22266 21.5743C3.22266 11.5036 11.1979 3.31063 21.001 3.31063C30.8041 3.31063 38.7793 11.5036 38.7793 21.5743C38.7793 31.6449 30.8041 39.8379 21.001 39.8379C17.5987 39.8379 14.293 38.8477 11.44 36.9747L10.8349 36.5773ZM50.3007 51.6738L45.7479 50.3797L45.1398 50.7862C42.7829 52.3592 40.0444 53.1907 37.2217 53.1907C30.9207 53.1907 25.3839 49.0055 23.4222 43.0041C33.0708 41.8613 40.749 33.9736 41.8618 24.0611C47.7033 26.0768 51.7773 31.7648 51.7773 38.2377C51.7773 41.1376 50.9679 43.9507 49.4367 46.3721L49.041 46.9967L50.3007 51.6738Z",
  fill: "#0747A6"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M19.3896 29.906H22.6123V33.2166H19.3896V29.906Z",
  fill: "#0747A6"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M24.2236 16.5531C24.2236 17.4933 23.851 18.3611 23.1746 18.9969L19.3896 22.5558V26.5954H22.6123V24.0137L25.3503 21.4393C26.6822 20.1871 27.4463 18.4063 27.4463 16.5531C27.4463 12.902 24.5551 9.93188 21.001 9.93188C17.4468 9.93188 14.5557 12.902 14.5557 16.5531H17.7783C17.7783 14.7276 19.2239 13.2425 21.001 13.2425C22.7781 13.2425 24.2236 14.7276 24.2236 16.5531Z",
  fill: "#0747A6"
});

var SvgHelp = function SvgHelp(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 57,
    viewBox: "0 0 55 57",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHelp, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/help.4b80afcf.svg";
export { ForwardRef as ReactComponent };